import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, inject, model, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DialogData } from '@app/new-company/new-company.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Organizations } from '@app/interface/organizations';
import { ReferralRequestInterface } from '@app/interface/referral-request';

export interface ReferralRequestDialogData {
  request: ReferralRequestInterface;
  organizationId: number;
  organization: Organizations;
}

@Component({
  selector: 'izy-referral-request-dialog',
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    // MatDialogClose,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatIconModule,
    MatDividerModule,
    ReactiveFormsModule,
  ],
  standalone: true,
  templateUrl: './referral-request-dialog.component.html',
  styleUrl: './referral-request-dialog.component.scss',
})
export class ReferralRequestDialogComponent {
  showDelay = new FormControl(700);
  hideDelay = new FormControl(1000);
  isLoading = false;

  referralForm: FormGroup;
  referralRequest: ReferralRequestInterface;
  organizationId: number;
  organization: Organizations | null;

  constructor(
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ReferralRequestDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReferralRequestDialogData,
  ) {
    this.referralForm = new FormGroup({});
    this.referralRequest = data.request;
    this.organizationId = data.organizationId;
    this.organization = data.organization;
  }

  ngOnInit(): void {
    // Initialize form with current subscription data
  }

  getReferralStatusDisplay(value: string | null | undefined): string {
    if (value === null || value === undefined) return 'Non specificato';

    const statusMap: Record<string, string> = {
      PENDING: 'ancora in attesa',
      ACCEPTED: 'stata accettata',
      EXPIRED: 'scaduta',
      FAILED: 'stata rifiutata',
    };

    return statusMap[value] || 'in stato non specificato';
  }

  copyMailToClipboard(): void {
    navigator.clipboard
      .writeText(this.data.request.mail)
      .then(() => {
        // You could show a small confirmation here or rely on the parent
        this.dialogRef.close(false); // Close with success
        this.showSuccessMessage('Indirizzo mail copiato negli appunti.');
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
        this.dialogRef.close(false); // Close with failure
      });
  }

  copyNumberToClipboard(): void {
    navigator.clipboard
      .writeText(this.data.request.telephone)
      .then(() => {
        // You could show a small confirmation here or rely on the parent
        this.dialogRef.close(false); // Close with success
        this.showSuccessMessage('Numero copiato negli appunti.');
      })
      .catch((err) => {
        console.error('Failed to copy: ', err);
        this.dialogRef.close(false); // Close with failure
      });
  }

  confirm(): void {
    if (this.referralForm.valid) {
      this.dialogRef.close(this.referralForm.value);
    }
  }

  private showSuccessMessage(message: string): void {
    this.snackBar.open(message, 'Chiudi', {
      duration: 3000,
      panelClass: ['success-snackbar'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
}
